<template>
  <v-dialog width="600" v-model="dialog">
    <v-card>
      <gg-toolbar @close="close">
        Remove Parked Domain
      </gg-toolbar>

      <v-card-text v-if="alias">
        <p class="mb-0">
          Are you sure you want to <strong>permanently</strong> remove the parked domain, “{{ alias.domain }}”?
        </p>
      </v-card-text>
      <v-card-actions class="justify-end">
        <gg-btn secondary @click="close">
          Cancel
        </gg-btn>
        <gg-btn :loading="loading" @click="deleteAlias">
          Remove
        </gg-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import modalMixin from '@/mixins/modal'

export default {
  name: 'DeleteAliasModal',
  mixins: [modalMixin],
  props: {
    alias: {
      required: true,
      validator (val) {
        return val === null || typeof val === 'object'
      }
    }
  },
  data () {
    return {
      loading: false,
    }
  },
  methods: {
    ...mapActions(['cpanel_api2', 'reportError', 'reportSuccess']),
    async deleteAlias () {
      this.loading = true
      let data = {
        api2_module: 'Park',
        api2_method: 'unpark',
        domain: this.alias.domain,
        _username: this.$route.query.user,
      }
      try {
        const response = await this.cpanel_api2({ ...data })
        if (response.payload.error) {
          this.reportError(response.payload.error)
          this.loading = false
          return
        }
        this.reportSuccess(`The parked domain ${data.domain} has been removed`)
        this.loading = false
        this.$emit('alias-removed')
        this.close()
      } catch (e) {
        this.loading = false
        this.reportError(e.resultmsg)
      }
    },
  },
}
</script>
